import { render, staticRenderFns } from "./Campaign.vue?vue&type=template&id=47e9e795&scoped=true&"
import script from "./Campaign.vue?vue&type=script&lang=js&"
export * from "./Campaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e9e795",
  null
  
)

export default component.exports